import React, { useLayoutEffect } from 'react';
import cx from 'classnames';
import errorImg from 'somethingsWrong.png';
import ErrorCard from 'rv-errorcard';
import Button from 'fk-cp-common-components/webComponents/V4/common/Button';
import styles from './ErrorCard.css';
import { FormattedMessage, formatMessage } from '../../../../utils/i18n';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
var onRefresh = function () {
    if (location) {
        location.reload();
    }
};
var ErrorCardNew = function (props) {
    var _a;
    useLayoutEffect(function () {
        /**
         * scroll to bottom -
         *   As the height is 90 vh and might have component of top of Error Card - e.g. - Filters
         *   This layouteffect keeps the scroll to the end of the page.
         *   Letting this component centered to viewPort.
         */
        window.scrollBy(0, window.innerHeight);
    }, []);
    return (<div className={cx(styles.pageLevelError, (_a = {}, _a[styles.pageLevelDeviceError] = !UAHelper._isMsite(), _a))}>
			<ErrorCard className={styles.pageLevelErrorCard} errorText={props.errorText || formatMessage({ id: 'errorMsg1' })} imgSrc={props.imgSrc || errorImg} imgSkewStyle={props.imgSkewStyle}/>
			{props.errorSubtext && <p className={styles.subText}>{props.errorSubtext}</p>}
			<Button className={styles.errCardBtn} onClick={props.onActionBtnClick ? props.onActionBtnClick : onRefresh}>
				{props.actionBtnText || <FormattedMessage id={props.actionBtnTextId || 'refresh'}/>}
			</Button>
		</div>);
};
export default ErrorCardNew;
